document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero');
  const bgLayer = document.querySelector('.hero-bg');
  const speed = 0.5; // 0 = static, 1 = scrolls normally, <1 = parallax

  function onScroll() {
    const scrollY = window.scrollY;
    const heroTop = hero.offsetTop;
    const heroHeight = hero.clientHeight;
    const dist = scrollY - heroTop;

    // only move while we’re in the hero
    if (dist >= 0 && dist <= heroHeight) {
      bgLayer.style.transform = `translateY(${dist * speed}px)`;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
